import { XRTracked } from "../XRTracked";

/**
 * The anchor in XR space.
 */
export class XRAnchor extends XRTracked {}
